import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines multiple class names using clsx and tailwind-merge
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a date to a readable string
 */
export function formatDate(date: Date | string): string {
  if (!date) return ''
  
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short', 
    day: 'numeric',
    year: 'numeric'
  })
}

/**
 * Formats a time to a readable string
 */
export function formatTime(date: Date | string): string {
  if (!date) return ''
  
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  })
}

/**
 * Formats a date and time to a readable string
 */
export function formatDateTime(date: Date | string): string {
  if (!date) return ''
  
  return `${formatDate(date)} at ${formatTime(date)}`
}

/**
 * Truncates a string to a specified length
 */
export function truncateString(str: string, length: number): string {
  if (!str) return ''
  if (str.length <= length) return str
  
  return str.slice(0, length) + '...'
}
